// Generated by genversion.
export const version = '2.20.2';
